import requester from '@/services/requester'
import env from '@/.env.js'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieveAppSettings(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/application-settings`,
            parameters
        )
    },

    retrieveClient(parameters) {
        return requester.post(
            `${BACKEND_API_V1_URL}/erp-integration/get-client`,
            parameters
        )
    },
}
